<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="门店列表"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box item-search">
                <search-box placeholder="门店名称/店长姓名/手机号码" @search="searchEvent" :btns="searchOtherBtn" @click="addEvent" />
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="tableData" height="250" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil"
                    >
                        <el-table-column prop="create_datetime" label="添加时间" width="180" />
                        <el-table-column prop="store_name" label="门店名称" width="150">
                            <template slot-scope="data">
                                {{data.row.store_name}}
                                <el-tag type="warning" v-if="data.row.is_main === '1'">&nbsp;总店&nbsp;</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="manager_name" label="店长姓名" width="150" />
                        <el-table-column prop="mobile" label="手机" width="150" />
                        <el-table-column prop="store_address" label="地址" />
                        <el-table-column label="操作" size="200">
                            <template slot-scope="data">
                                <el-button
                                        size="mini"
                                        type="primary"
                                        @click="handleEdit(data.$index, data.row)"
                                >编辑</el-button>
                                <el-button
                                        size="mini"
                                        type="success"
                                        v-if="data.row.is_main === '1'"
                                        @click="syncOption(data.$index, data.row)"
                                >同步配置</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page-box">
                    <el-pagination
                            @size-change="pageSizeChange"
                            @current-change="pageCurrentChange"
                            :current-page="page.nowPage"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.count">
                    </el-pagination>
                </div>

            </div>
        </div>
        <div class="layout-right-bottom">

        </div>

        <!--添加连锁门店提交-->
        <ChainEditChildStore v-model="editShow" @reload="loadListData" :id="editId" />
        <!--同步配置-->
        <ChainSyncOption v-model="syncShow" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import RightTop from "@/model/RightTop";
    import ChainEditChildStore from "@/model/Chain/ChainEditChildStore";
    import ChainSyncOption from "@/model/Chain/ChainSyncOption";
    export default {
        name: "StoreList",
        components: {ChainSyncOption, ChainEditChildStore, RightTop, SearchBox, Menu},
        data(){
            return {
                searchValue: "",
                searchOtherBtn: [
                    {
                        label: "添加门店"
                    }
                ],
                tableData: [],
                editShow: false,
                editId: "",
                syncShow: false,   //同步配置
                page: {
                    nowPage: 1,
                    pageSize: 50,
                    pageSizes: [50, 100, 200, 400],
                    count: 0,
                },
            };
        },
        mounted: function(){
            this.$store.commit("setMenuId", "14-2");
            this.loadListData();
        },
        methods: {
            //每页显示数量变化
            pageSizeChange(val) {
                this.page.pageSize = val;
                this.loadListData();
            },

            //当前页码变化
            pageCurrentChange(val) {
                this.page.nowPage = val;
                this.loadListData();
            },

            //添加分店
            addEvent() {
                this.editId = null;
                this.editShow = true;
            },

            //搜索事件
            searchEvent(data) {
                this.searchValue = data.keyword ? data.keyword : "";
                this.loadListData();
            }

            //加载列表数据
            ,loadListData() {
                let postData = {
                    offset: (this.page.nowPage - 1) * this.page.pageSize,
                    limit: this.page.pageSize,
                    keyword: this.searchValue,
                };
                this.$root.postData("chain/get_child_store_list", postData, res => {
                    if(res.errcode === 0) {
                        this.tableData = res.data.listData;
                        this.page.count = res.data.count;
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            }

            //编辑
            ,handleEdit(index, data){
                this.editId = data.id;
                this.editShow = true;
            }

            //同步
            ,syncOption(index, data){
                this.syncShow = true;
            }



            //查看
            ,handleInfo: function (index, data) {
                this.$store.dispatch("setSession", {
                    store_id: data.store_id
                });
                obj.innerGo("/");
            }
        },
    }
</script>

<style scoped>
    .layout-right-body>.item-search{
        height: 72px;
    }
    .layout-right-body>.item-content{
        border-radius: 5px;
        background-color: #ffffff;
        padding-bottom: 10px;
    }
    .item-content>.table-box{
        padding: 0 16px;
    }
    .el-table::before{
        height: 0;
    }
    .layout-right-bottom{
        padding-top: 0px;
        padding-bottom: 0px;
    }

</style>
